<!-- Modal Header -->
<ng-container>
  <div class="cx-modal-container">
    <div class="cx-modal-content">
      <header class="cx-dialog-header modal-header saved-cart-modal-header">
        <div class="cx-dialog-title modal-title">
          {{ 'pdp.myfavourite' | cxTranslate }}
        </div>
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="dismissModal('close')"
        >
          <span aria-hidden="true">
            <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
          </span>
        </button>
      </header>
      <form [formGroup]="createFavouriteCartForm">
        <!-- Modal Body -->
        <div class="vs-dialog-body modal-body saved-cart-modal-body">
          <p class="dialog-hint">{{ 'pdp.favdialogHint' | cxTranslate }}</p>
          <div class="form-group">
            <div class="form-control-wrapper clearfix">
              <label>
                <span class="label-content">
                  {{ 'pdp.description' | cxTranslate }}
                </span>
                <textarea
                  class="form-control"
                  name="description"
                  formControlName="description"
                  [(ngModel)]="favouriteDescription"
                  maxlength="255"
                  #FavDescription
                ></textarea>
                <div class="char-left">
                  {{ 'pdp.charLeft' | cxTranslate }}:
                  {{ 255 - FavDescription.value.length }}
                </div>
                <!-- <cx-form-errors [control]="createFavoriteCartForm.get('description')"></cx-form-errors> -->
              </label>
            </div>
          </div>
          <footer class="modal-footer saved-cart-modal-footer">
            <!-- Actions -->
            <div class="vs-modal-buttons">
              <button
                class="btn vs-text-btn btnClass cancleBtnClass"
                (click)="dismissModal('cancel-my-fav-pdp')"
              >
                {{ 'pdp.cancel' | cxTranslate }}
              </button>
              <button class="btn vs-primary-btn btnClass" (click)="onSubmit()">
                {{ 'pdp.save' | cxTranslate }}
              </button>
            </div>
          </footer>
        </div>
      </form>
    </div>
  </div>
</ng-container>
